module.exports = __webpack_public_path__ + "static/media/mouses.31dc3378.png";